Alerts = require 'views/lib/alerts'
ApiPromise = require 'network/api-promise'
Auth = require('db/auth')
Keyboard = require 'lib/keyboard'
l = require 'lib/localize'
logError = require 'debug/log-error'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
t = require('views/internal/teacup-with-helpers')('change_email')
track = require 'debug/track'
Util = require 'lib/util'
View = require 'view'

template = t.renderable ({ currentEmail }) ->
  t.p '.error.account-error'

  t.label ->
    t.format 'current-email'
  t.div '.js-current-email', ->
    t.text currentEmail

  t.br()

  t.label ->
    t.format 'new-email'
    t.input '.full.js-new-email.js-autofocus'

  t.button '.primary.full.js-save-changes.disabled', { disabled: true }, ->
    t.format 'change-email'

confirmationRequired = t.renderable ({ email }) ->
  t.p ->
    t.format 'we-sent-an-email-to-the-address-you-entered', { email }
  t.p ->
    t.format 'click-the-link-in-the-email'

module.exports = class ChangeEmailView extends View
  viewTitleKey: 'change email'
  className: 'member-change-email'
  events:
    'click .js-save-changes': 'saveChanges'
    'keydown .js-new-email': (e) ->
      if Keyboard.isSubmitEvent(e)
        @$('.js-save-changes').click()

    'input .js-new-email': (e) ->
      email = @$('.js-new-email').val()
      isValid = /@[^\.]+\.[^\.]+/.test(email)

      if isValid
        @_loginsPromise.then =>
          if email == @$('.js-new-email').val()
            exists = @model.loginList.any (login) ->
              login.get('email') == email
            @$('.js-send-confirmation').toggleClass('hide', exists)
            @$('.js-update-email').toggleClass('hide', !exists)

      disabled = !isValid
      @$('.js-save-changes')
      .prop('disabled', disabled)
      .toggleClass('disabled', disabled)

  initialize: ->
    @_loginsPromise = ModelLoader.loadMemberLogins('me')

  render: ->
    me = Auth.me()
    currentEmail = me.get('email')

    @$el.html(template({
      currentEmail
    }))

    @_loginsPromise.then =>
      @$('.js-current-email').text(me.get('email'))
    @

  showError: (msg, email) ->
    domain = ''
    key = switch msg.trim().toLowerCase()
      when 'the email address is already in use'
        'address in use'
      when 'this email is already on this account'
        'on account'
      when 'invalid email address'
        'invalid email address'
      when 'the email address is from a forbidden domain'
        domain = email.split('@')[1]
        'email domain forbidden'
      else
        logError new Error("Unknown server error message '#{msg}'")
        'unknown'

    @$('.account-error').text(l(['email error', key], { domain })).show()

  saveChanges: (e) ->
    Util.preventDefault(e)

    $button = @$('.js-save-changes')
    email = @$('.js-new-email').val()

    $button.prop('disabled', true).addClass('disabled')

    @_loginsPromise.then =>
      existingLogin = @model.loginList.find (login) -> login.get('email') == email
      if existingLogin
        @model.set('email', email)
        ApiPromise
          url: "/1/members/me/logins/#{ existingLogin.id }/primary"
          type: 'put'
        .then (data) =>
          existingLogin.set('primary', true)
          PopOver.popView()
        .done()
      else
        @model.run 'logins', { email, primary: true }, (err) =>
          if err
            $button.prop('disabled', false).removeClass('disabled')
            @showError(err.message, email)
          else
            @$el.html(confirmationRequired({ email }))
            track('Member', 'Changed Email Address')
          return



// WEBPACK FOOTER //
// ./app/scripts/views/member/change-email-popover-view.coffee